import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const NewPassForm = lazy(() => import('components/Sections/NewPass'))
const Footer = lazy(() => import('components/Layout/Footer'))

function NewPass() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <NewPassForm />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default NewPass